import { msalInstance } from "../auth/authHandler";

export const combineClassNames = (
  classNames: (string | undefined | boolean)[],
) => {
  return classNames.filter(Boolean).join(" ").trim();
};

export const showExperimentalFeatures = () => {
  return msalInstance
    .getAllAccounts()
    .some((account) => account.username.endsWith("@stormgeo.com"));
};

export const isAuthUrl = (url?: string) => {
  if (!url) return false;
  let urlObj: URL;
  try {
    urlObj = new URL(url);
  } catch {
    return false;
  }
  const host = urlObj.host;
  if (
    ![
      "k25fag4ezj.execute-api.eu-north-1.amazonaws.com",
      "xlznuv78s4.execute-api.eu-north-1.amazonaws.com",
      "y6cwn1fb5j.execute-api.eu-north-1.amazonaws.com",
    ].includes(host)
  )
    return false;
  if (["/api/tiler/", "/api/vector/"].some((u) => urlObj.pathname.includes(u)))
    return true;

  return new URLSearchParams(urlObj.search).get("sendAuthToken") === "true";
};
